export default (state: false, action: any) => {
  switch (action.type) {
    default:
      return false;
  }
};
